<svelte:head>
  <link rel="stylesheet" href="/index.css" />
  <link rel="stylesheet" href="/build/bundle.min.css" />
  <link rel="shortcut icon" type="image/png" href="/favicon.png" />
</svelte:head>
<header class="w-11/12 h-10 mx-auto my-8 flex justify-between">
  <a class="flex items-center" href="/">
    <!-- Created from https://www.physicsandmathstutor.com/ -->
    <img
      class="inline-block"
      style="height: 2.5em;"
      src="./favicon.png"
      alt="Logo"
    />
    <h1 class="inline-block ml-4">Physics & Maths Pirate</h1>
  </a>
</header>
